export class ApiToken {
  static get PROPIEDADES_EXPORTAR() {
    return [
      { value: "IdSec", label: "Id" },
      { value: "Nombre", label: "Nombre" },
      { value: "FechaCreacion", label: "Fecha Expedición" },
      { value: "_ExpiraDesc", label: "Expira" },
      { value: "FechaExpiracion", label: "Fecha Expiración" },
      { value: "UsuarioAsociado", label: "Usuario" },
      { value: "_EstatusDesc", label: "Estatus" },
      { value: "Token", label: "Token" },
      { value: "CrearUsuario", label: "Usuario Creación" },
      { value: "FechaCreacion", label: "Fecha Creación" },
      { value: "ActualizarUsuario", label: "Usuario Actualización" },
      { value: "FechaActualizacion", label: "Fecha Actualización" },
    ]
  }
}